module.exports = __webpack_public_path__ + "img/greyInfo.bf6494ee.svg";